/**
 * @import { AnsiPalette } from '../ansi.types.js'
 */

/** @type {AnsiPalette} */
export default {
  foreground: '#000000',
  background: '#FFFFFF',
  'background-hover': '#F5F5F5',
  'background-selected': '#EBEBEB',
  black: '#000000',
  red: '#990000',
  green: '#0C7814',
  yellow: '#6D6B12',
  blue: '#0000B2',
  magenta: '#B200B2',
  cyan: '#28757B',
  white: '#BFBFBF',
  'bright-black': '#666666',
  'bright-red': '#D60000',
  'bright-green': '#00D900',
  'bright-yellow': '#E5E500',
  'bright-blue': '#0000FF',
  'bright-magenta': '#E500E5',
  'bright-cyan': '#00E5E5',
  'bright-white': '#E5E5E5',
};
